import { render, staticRenderFns } from "./Sat.vue?vue&type=template&id=0a20ec56&scoped=true&"
import script from "./Sat.vue?vue&type=script&lang=ts&"
export * from "./Sat.vue?vue&type=script&lang=ts&"
import style0 from "./Sat.vue?vue&type=style&index=0&id=0a20ec56&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a20ec56",
  null
  
)

export default component.exports